import type { SVGProps } from "react";

/**
 * Small, hand-authored stroke icon set — avoids pulling in an icon
 * library dependency for ~10 glyphs. Consistent 1.75 stroke weight,
 * 24x24 viewbox, currentColor.
 */

function base(props: SVGProps<SVGSVGElement>) {
  return {
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    "aria-hidden": true,
    ...props,
  };
}

export function TodayIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base(props)}>
      <circle cx="12" cy="12" r="4.5" />
      <path d="M12 2.5v2.2M12 19.3v2.2M4.2 4.2l1.6 1.6M18.2 18.2l1.6 1.6M2.5 12h2.2M19.3 12h2.2M4.2 19.8l1.6-1.6M18.2 5.8l1.6-1.6" />
    </svg>
  );
}

export function BriefingsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base(props)}>
      <path d="M4 4.5h11a2 2 0 0 1 2 2V19a1.5 1.5 0 0 1-1.5 1.5H6A2 2 0 0 1 4 18.5V4.5Z" />
      <path d="M17 6.5H19a1 1 0 0 1 1 1V17a2 2 0 0 1-2 2h-1" />
      <path d="M7.2 8.3h6.6M7.2 11.3h6.6M7.2 14.3h4.2" />
    </svg>
  );
}

export function CalendarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base(props)}>
      <rect x="3.5" y="5" width="17" height="15.5" rx="2" />
      <path d="M3.5 9.5h17M8 3v4M16 3v4" />
      <circle cx="8.2" cy="13.2" r="1" fill="currentColor" stroke="none" />
      <circle cx="12.2" cy="13.2" r="1" fill="currentColor" stroke="none" />
      <circle cx="8.2" cy="16.6" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function SourcesIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base(props)}>
      <circle cx="12" cy="12" r="2.2" />
      <path d="M8.3 15.7a5.3 5.3 0 0 1 0-7.4M15.7 8.3a5.3 5.3 0 0 1 0 7.4M5.4 18.6a9.6 9.6 0 0 1 0-13.2M18.6 5.4a9.6 9.6 0 0 1 0 13.2" />
    </svg>
  );
}

export function SystemIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base(props)}>
      <circle cx="12" cy="13" r="7.5" />
      <path d="M12 13 15 9.2M9 4.5h6" />
    </svg>
  );
}

export function MenuIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base(props)}>
      <path d="M4 6.5h16M4 12h16M4 17.5h16" />
    </svg>
  );
}

export function CloseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base(props)}>
      <path d="M6 6l12 12M18 6L6 18" />
    </svg>
  );
}

export function ExternalLinkIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base(props)}>
      <path d="M9.5 6.5h-3A2 2 0 0 0 4.5 8.5v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-3" />
      <path d="M14 4.5h5.5V10M19.3 4.7l-9 9" />
    </svg>
  );
}

export function ChevronLeftIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base(props)}>
      <path d="M14.5 6 9 12l5.5 6" />
    </svg>
  );
}

export function ChevronRightIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base(props)}>
      <path d="M9.5 6 15 12l-5.5 6" />
    </svg>
  );
}

export function AlertIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base(props)}>
      <path d="M12 3.5 21.5 20h-19L12 3.5Z" />
      <path d="M12 10v4.2M12 17.2v.1" />
    </svg>
  );
}

export function InboxIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base(props)}>
      <path d="M4 12.5h4.2l1.3 2.3h4.9l1.3-2.3H20" />
      <path d="M4 12.5 6.2 5A1.5 1.5 0 0 1 7.6 4h8.8a1.5 1.5 0 0 1 1.4 1l2.2 7.5v5A1.5 1.5 0 0 1 18.5 19h-13A1.5 1.5 0 0 1 4 17.5v-5Z" />
    </svg>
  );
}
